import React, { useEffect, useState } from 'react';
import { useUrlFriendlyToParameters, useNavigateTo, useGetURL } from 'helpers/urlFriendly';
import { getRecords } from "data/Querys";
import { useQuery } from "@tanstack/react-query";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";

import Label from "components/general/Label"
import MirsTable from 'components/general/table/Table.js';
import { useMemo } from 'react';
import { ALL_URL, SELECTOR_DISPLAY_TYPE, dateFormat, getDateTimeFormat } from "helpers/utils"
import SportCode from "components/common/SportCode"
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from "components/presentation/Noc";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import SelectorEvent from "components/common/selectors/SelectorEvent";
import SelectorNoc from 'components/common/selectors/selector-noc';
import { Stack } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import useViewport from 'components/general/useViewPort';
import { Link } from 'react-router-dom';
import SelectorRecord from 'components/common/selectors/selector-record';
import { ResetFilterButton } from 'components/common/ResetFilterButton';
import { useGetH1 } from 'helpers/commonCodes';


const DisciplineRecords = () => {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs";
    const [dataRecords, setDataRecords] = useState([]);
    const [selectedNoc, setSelectedNoc] = useState('');
    const [selectedRecord, setSelectedRecord] = useState('');
    const [isBrokenRecordsSelected, setIsBrokenRecordsSelected] = useState(false);
    const [nocs, setNocs] = useState([]);
    const [events, setEvents] = useState([]);
    const [records, setRecords] = useState([]);
    const [isDisabledBrokenRecordsCheck, setIsDisabledBrokenRecordsCheck] = useState(false);
    const params = useUrlFriendlyToParameters()
    const getURL = useGetURL()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "records")
    const { h1s } = useGetH1({ mirs_competition });
    const disciplineHasTeamProfile = useMemo(() => h1s?.some(h => h.orisNo === 'N22' && h?.disciplineCode === mirs_discipline), [h1s, mirs_discipline]);

    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   

    const getColumnsXl = () => {
        return (
            [
                ColumnEvent({ paramsURL, getURL }),
                ColumnRecordType({}),
                ColumnName({ disciplineHasTeamProfile }),
                ColumnRecordValue({}),
                ColumnLocation({}),
                ColumnDate({})
            ]
        )
    }

    const getColumnsXs = () => {
        return (
            [
                ColumnEvent({ paramsURL, getURL }),
                ColumnRecordType({}),
                ColumnNameLocationDate({ disciplineHasTeamProfile }),
                ColumnRecordValue({}),
            ]
        )
    }
    const tableColumns = useMemo(() => isMobile ? getColumnsXs() : getColumnsXl(), [isMobile])
    //DATA
    const { data, isError, isLoading } = useQuery({
        queryKey: ['recordsByDiscipline', mirs_competition, mirs_language, mirs_discipline],
        queryFn: getRecords,
        refetchInterval: 0,
    });

    useEffect(() => {
        let dataFilter = data?.records;
        let tempDataRecords = [];
        // if recordData has one item , it will be withDescription,
        // if recordData has multiple items, reverse it, set withDescription =true  in the item with greater order, to display record description
        if (Array.isArray(dataFilter) && dataFilter.length > 0) {
            dataFilter.forEach(item => {
                item.recordData?.sort((a, b) => b?.order - a?.order).forEach((ath, index) => {
                    tempDataRecords.push(
                        {
                            "recordCode": item?.recordCode,
                            "recordOrder": item?.order,
                            "recordType": { ...item?.recordType },
                            "record": { ...item?.record },
                            "athlete": { ...ath, withDescription: index === 0 ? true : false },
                            "notEstablished": item?.notEstablished,
                            "notEstablishedLabel": item?.notEstablishedLabel
                        }
                    )
                });
            });
        };

        let tempNocs = new Set();
        let tempEvents = new Set();
        let tempRecords = new Set();
        let isBroken = false;

        tempDataRecords = tempDataRecords?.filter(item => {

            //! get smart filter data inside filter method to reduce number of iterations
            let tempNoc = item?.athlete?.competitor?.organisation?.code;
            let tempEvent = item?.record?.event;
            let tempRecord = { code: item?.recordType?.code?.substring(3), description: item?.recordType?.description };
            let tempIsBroken = !item?.athlete?.historic;

            if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
                if (item?.record?.event !== mirs_event) {
                    tempNoc = '';
                    tempRecord = '';
                    tempIsBroken = false;
                };
            };
            if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
                if (item?.athlete?.competitor?.organisation?.code !== selectedNoc) {
                    tempEvent = '';
                    tempRecord = '';
                    tempIsBroken = false;
                };
            };

            if (selectedRecord && selectedRecord !== ALL_URL.ALL_RECORD) {
                if (item?.recordType?.code?.substring(3) !== selectedRecord) {
                    tempNoc = '';
                    tempEvent = '';
                    tempIsBroken = false;
                };
            };

            if (isBrokenRecordsSelected) {
                if (item?.athlete?.historic !== false) {
                    tempNoc = '';
                    tempEvent = '';
                    tempRecord = '';
                }
            }
            if (tempIsBroken) {
                isBroken = tempIsBroken;
            }
            if (tempNoc) {
                tempNocs.add(tempNoc);
            };
            if (tempEvent) {
                tempEvents.add(tempEvent);
            };
            if (tempRecord) {
                tempRecords.add(tempRecord);
            };


            //! start of filteration logic
            let eventfilter = true;

            let nocFilter = true;

            let recordFilter = true;

            let brokenRecordFilter = true;

            if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
                eventfilter = item?.record?.event === mirs_event;
            };
            if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
                nocFilter = item?.athlete?.competitor?.organisation?.code === selectedNoc;

            };
            if (selectedRecord && selectedRecord !== ALL_URL.ALL_RECORD) {
                recordFilter = item?.recordType?.code?.substring(3) === selectedRecord;
            };
            if (isBrokenRecordsSelected) {
                brokenRecordFilter = item?.athlete?.historic === false;
            };
            const filterResult = eventfilter && nocFilter && recordFilter && brokenRecordFilter;

            return filterResult;
        });
        setIsDisabledBrokenRecordsCheck(!isBroken);

        setDataRecords(tempDataRecords);
        setEvents([...tempEvents]);
        setNocs([...tempNocs]);
        setRecords(filterDuplicates([...tempRecords]));
    }, [data?.records, isBrokenRecordsSelected, mirs_event, selectedNoc, selectedRecord]);

    if (isError) { return <NotAvailable label="LabelNoDataAvailable" />; }
    if (isLoading) { return <Loader />; }
    if (!data) { return <NotAvailable label="LabelNoDataAvailable" /> }

    const handleOnChange = (e) => {
        setIsBrokenRecordsSelected(e.target.checked ? true : false)
    };

    const onSelectNoc = (nocCode) => {
        setSelectedNoc(nocCode)
    }
    const onSelectRecord = (recordCode) => {
        setSelectedRecord(recordCode)
    }
    function filterDuplicates(array) { const seen = new Set(); return array?.filter(item => { const duplicate = seen?.has(item?.code); seen?.add(item?.code); return !duplicate; }); } // Filter the array of objectsconst filteredArray = filterDuplicates(arrayOfObjects);

    const onClearFilters = () => {
        setSelectedNoc('');
        setSelectedRecord('');
        setIsBrokenRecordsSelected(false);
    }

    return (<>
        <Stack direction={'horizontal'} className='selectors-container'>
            <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="records" displayAllDisc={false} />
            <SelectorEvent page="records" useEventList={true} eventList={events} />
            <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="records" nocsList={nocs} useNocList={true} onSelectNoc={onSelectNoc} selectedNoc={selectedNoc} />
            <SelectorRecord page="records" recordsList={records} useRecordsList={true} onSelectRecord={onSelectRecord} selectedRecord={selectedRecord} />
            <Form.Check checked={isBrokenRecordsSelected} label={<Label data='LabelOnlyBrokenRecords' htmlFor="brokenRecord" />} id="brokenRecord" name="brokenRecord" type="checkbox" disabled={isDisabledBrokenRecordsCheck && !isBrokenRecordsSelected} onChange={(e) => handleOnChange(e)} />
            <ResetFilterButton page='records' selectedNoc={selectedNoc} selectedRecord={selectedRecord} isBrokenRecordsSelected={isBrokenRecordsSelected} onClearFilters={onClearFilters} />
            {/* // recordPageProps = { selectedNoc: '', selectedRecord: '', isBrokenRecordsSelected: false, onClearFilters: () => { } } */}

        </Stack>
        {dataRecords && <MirsTable
            id={`mirs-table-records`}
            data={dataRecords}
            columns={tableColumns}
            showLoading={false}
            initialSortBy={[{ id: 'Event', desc: false }, { id: 'RecordName', desc: false }]}
        />}


    </>);
};


export function ColumnEvent({
    paramsURL = {},
    getURL = {}
}) {

    return (
        {
            Header: <Label data="HeaderEvent" />,
            accessor: 'record.order',
            headerClassName: 'text-start w-25',
            id: 'Event',
            Cell: (props) => {
                const row = props.cell.row.original
                let params = { ...paramsURL }
                params["mirs_event"] = row.record?.event
                params["mirs_rsc"] = row.athlete?.eventUnit?.code
                const url = getURL(params, "results")
                return (
                    <>
                        {row?.athlete?.withDescription && <div className='text-wrap'>{row.record?.description}</div>}
                        {!row.athlete?.historic && <Link to={url}>{row.athlete?.eventUnit?.shortDescription}</Link>}
                    </>
                )
            }
        }
    )
}

function ColumnRecordType({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-5',
    label = 'HeaderType',
    headerRecord = undefined,
}) {
    return (
        {
            Header: (props) => {
                let labelCode = headerRecord ? headerRecord : <><Label data={label} /></>;
                return (labelCode)
            },
            accessor: 'recordOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordName',
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    !!row?.athlete?.withDescription && <abbr title={props.cell.row.original.recordType?.description}>{props.cell.row.original?.recordType?.code?.substring(3)}</abbr>
                )
            }
        }
    )
}


export function ColumnNoc({

    disableSort = true,
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5',
    label = 'HeaderTeamNOC',
    remove = false
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'NOC',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = row?.athlete?.competitor?.organisation
                const current = row?.athlete?.current;
                const historic = row?.athlete?.historic;

                let out;
                if (current && !historic) {
                    out = <><div className='d-flex align-items-end'><span className='newRecord'><Label data={'LabelNew'} /></span> <Noc {...data} /></div ></>
                } else {
                    out = <Noc {...data} />
                }
                return (out)
            }
        }
    )

}

function ColumnName({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = '-',
    hideNoc = false,
    disciplineHasTeamProfile = false
}) {

    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else {
                    lbl = row?.record?.event?.includes('K4') ? 'HeaderTeam' : 'HeaderName'
                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: 'athlete.competitor.code',
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters();
                const row = props.cell.row.original;
                let nolink = false;

                if (!row?.athlete?.competitor && row?.notEstablished) {
                    return <SportCode code={row?.notEstablishedLabel} discipline={mirs_discipline} entity="@NoRecord" />
                } else if (!row?.athlete?.competitor) {
                    return ''
                }
                const competitorData = row?.athlete?.competitor?.participant;
                nolink = competitorData?.code && competitorData?.current && ((row?.athlete?.competitor?.participant?.__typename === "Team" && disciplineHasTeamProfile) || row?.athlete?.competitor?.participant?.__typename === "Person") ? false : true;
                const current = row?.athlete?.current;
                const historic = row?.athlete?.historic;
                const showImgAlt = row?.athlete?.competitor?.participant?.__typename !== "Team"

                return (<Stack direction='vertical'>
                    <Stack direction='horizontal' className='align-items-end'>
                        {current && !historic && <span className='newRecord'><Label data={'LabelNew'} /></span>}
                        <Noc {...row?.athlete?.competitor?.participant?.organisation} showImgAlt={showImgAlt} />
                        <Competitor {...competitorData} hidePicture={true} hideNoc={hideNoc} noLink={nolink} />
                    </Stack>
                    {row?.athlete?.competitor?.participant?.__typename === "Team" && row?.athlete?.competitor?.athletes?.map(athlete => {
                        const athleteHasNoLink = athlete.code && athlete?.participant?.current && disciplineHasTeamProfile ? false : true;
                        return <Competitor {...athlete?.participant} hidePicture={true} hideNoc={hideNoc} noLink={athleteHasNoLink} key={athlete?.code} />
                    })}
                </Stack>
                );
            }
        }
    )
}


function ColumnRecordValue({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = "",
    resultType = "",
    forceResultTypeHader = undefined
}) {
    return (
        {
            Header: (props) => {
                const resultType = props?.data[0]?.recordDataFiltered?.resultType;
                let labelCode = resultType === 'DISTANCE' ? 'HeaderDistance' : resultType === 'POINTS' ? 'HeaderPoints' : resultType === 'TIME' ? 'HeaderTime' : 'HeaderMark';
                labelCode = forceResultTypeHader ? forceResultTypeHader : labelCode;
                return (<Label data={labelCode} />)
            },
            accessor: 'athlete.result',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'RecordValue',
        }
    )
}

function ColumnLocation({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = 'HeaderLocation',
    accessor = 'athlete.place'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Location'
        }
    )
}


function ColumnDate({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderDate',
    accessor = 'athlete.recordDate'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Date',
            Cell: props => getDate(props.cell.row.original)
        }
    )
}



function ColumnNameLocationDate({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-15',
    label = 'HeaderName',
    hideNoc = true,
    accessor = 'athlete.competitor.code',
    disciplineHasTeamProfile = false
}) {
    return (
        {
            Header: <><Label data={'HeaderName'} /> / <Label data={'HeaderLocation'} /></>,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'NameLocationDate',
            Cell: (props) => {
                const row = props.cell.row.original;
                const { mirs_discipline } = useUrlFriendlyToParameters();
                let nolink = false;
                const competitorData = row?.athlete?.competitor?.participant;
                nolink = competitorData?.code && competitorData?.current && ((row?.athlete?.competitor?.participant?.__typename === "Team" && disciplineHasTeamProfile) || row?.athlete?.competitor?.participant?.__typename === "Person") ? false : true;
                const current = row?.athlete?.current;
                const historic = row?.athlete?.historic;

                if (!row?.athlete?.competitor && row?.notEstablished) {
                    return <SportCode code={row?.notEstablishedLabel} discipline={mirs_discipline} entity="@NoRecord" />
                } else if (!row?.athlete?.competitor) {
                    return ''
                }

                return (<Stack direction='vertical'>
                    <Stack direction='horizontal' className='align-items-end'>
                        {current && !historic && <span className='newRecord'><Label data={'LabelNew'} /></span>}
                        <Noc {...row?.athlete?.competitor?.participant?.organisation} hideNocCode={true} />
                        <Competitor {...competitorData} hidePicture={true} hideNoc={hideNoc} noLink={nolink} />
                    </Stack>
                    {row?.athlete?.competitor?.participant?.__typename === "Team" && row?.athlete?.competitor?.athletes?.map(athlete => {
                        const athleteHasNoLink = athlete.code && athlete?.participant?.current && disciplineHasTeamProfile ? false : true;
                        return <Competitor {...athlete?.participant} hidePicture={true} hideNoc={hideNoc} noLink={athleteHasNoLink} key={athlete?.code} />
                    })}
                    <Stack direction="horizontal">
                        {getDate(row)}&nbsp;&nbsp;{row?.athlete.place}
                    </Stack>
                </Stack>);
            }
        }
    )
}

export default DisciplineRecords;

const getDate = row => {
    const format = getDateTimeFormat('DayMonthShortYear');
    return row?.athlete?.recordDate && dateFormat(row?.athlete?.recordDate, "", format)
}

const getName = (row, discipline, hideNoc) => {

    let nolink = false;

    if (!row?.athlete?.competitor) {
        return ''
    }

    let out = '';
    let organisation = row?.athlete?.competitor?.organisation
    if (row?.athlete?.competitor?.athletes && Array.isArray(row?.athlete?.competitor?.athletes) && row?.athlete?.competitor?.athletes.length > 0) {
        // has array of athletes
        // display  names
        out = [];
        row?.athlete?.competitor?.athletes?.forEach((ath, index) => {
            const athleteName = ath?.familyName?.toUpperCase() + ' ' + ath?.givenName;
            const athleteShortName = ath?.familyName?.toUpperCase() + ' ' + ath?.givenName?.slice(0, 1);
            const athleteCode = ath?.code
            const athleteData = { name: athleteName, shortName: athleteShortName, code: athleteCode };
            nolink = athleteData.code === undefined ? true : false
            out.push(
                <Competitor {...athleteData} hidePicture={true} hideNoc={hideNoc} noLink={nolink} key={athleteData?.code} organisation={organisation} />
            );
        });
    } else if (row?.athlete?.competitor?.participant) {
        const athleteName = row?.athlete?.competitor?.participant?.name;
        const athleteShortName = row?.athlete?.competitor?.participant?.shortName;
        const athleteCode = row?.athlete?.competitor?.participant?.shortName;
        const athleteData = { name: athleteName, shortName: athleteShortName, code: athleteCode };
        nolink = athleteData.code === undefined ? false : true
        out = <Competitor {...athleteData} hidePicture={true} hideNoc={hideNoc} noLink={nolink} organisation={organisation} />
    }



    if (out) {
    } else if (row?.notEstablished) {
        out = <SportCode code={row?.notEstablishedLabel} discipline={discipline} entity="@NoRecord" />
    }

    return (
        out
    )

}

